import Moment from 'react-moment';

const NiceSignMode = (props) => {

const mode = props.children

const modes = new Map([
  ['0', 'nothing the display off'],
  ['1', 'messages'],
  ['2', 'the time'],
  ['3', 'the date'],
  ['4', 'the time and date'],
  ['5', 'the temp at the sign'],
  ['6', 'the light Level at the sign'],
  ['7', 'the humidity at the sign'],
  ['8', 'an image'],


]);
return (
      'Displaying ' +  modes.get(mode)
  )
}

export default NiceSignMode;